import React, { useState, useEffect } from "react";
import { isEmpty } from "../libs/isEmpty";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Grid } from "@material-ui/core";
import TextFieldFullWidth from "../components/TextFieldFullWidth";
import { useFormFields } from "../libs/hooksLib";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import FileUpload from './FileUpload';
import Button from '@material-ui/core/Button';
import { useCardStyles } from '../styles/commonStyles';

export default function DokumentView({
  ...props
}) {

  const initialState = {
       active: false,
       alias: "",
       geom: "",
       doc_id: ""
    }

  const classes = useCardStyles();
  const [isVendorless, setIsVendorless] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [fields, setValues, handleFieldChange] = useFormFields(initialState);
  const [showMap, setShowMap] = useState(false)
  const [hasFile, setHasFile] = useState(false)
  const [docId, setDocId] = useState('')
  const [formCreateMode, setFormCreateMode] = useState(false)

  useEffect(() => {
    if (isEmpty(props.vendorMeta)) {
      setIsVendorless(true)
    } else {
      setIsVendorless(false)
      //console.log(props)
    }
  }, [props.vendorMeta])

  useEffect(() => {
    getValues()
  }, [props.doc])

  const rows = []

  async function saveAs(uri, filename) {
    var link = document.createElement('a');
    if (typeof link.download === 'string') {
        document.body.appendChild(link); // Firefox requires the link to be in the body
        link.download = filename;
        link.href = await uri;
        //console.log(link)
        link.click();
        document.body.removeChild(link); // remove the link when done
    } else {
        window.open(uri);
    }
}

  function handleMap(){
    setShowMap(!showMap)
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);

    let body = { body: fields }
    //console.log(body)

    if (formCreateMode) {
      props.create(body)
    } else {
      props.edit(body)
    }
  }

  function getValues() {
    //console.log(props)
    if (isEmpty(props.doc)) {
      setValues(initialState)
      setHasFile(false)
      setFormCreateMode(true)
    } else {
      setValues({ ...initialState, ...props.doc })
      setHasFile(true)
      setFormCreateMode(false)
    }
  }

  // Handle validation
  function validateForm() {
    let errors = []

    if (fields.alias.length === 0) {
      errors.push("Alias: må ikke være tom.")
    }

    if (hasFile) {
      errors.push("Dokument skal være defineret.")
    }

    if (errors.length > 0) {
      return false
    } else {
      return true
    }
  }
    
  


  //console.log(rows)
  return (
    <Card
      className={classes.root}
      raised
    >
      <CardHeader title="Dokument" />
      <CardContent>
        {isEmpty(props.doc) ? (
          <>
          <ListItem className={classes.listitem} key={"addDatasource"}>
        <ListItemText>
         Intet dokument valgt.
        </ ListItemText>
          </ListItem>        
          </>
        ) : (
          <>
          <form noValidate autoComplete="off"
        onSubmit={handleSubmit}
        key={'documentForm'}>
        <Grid 
        container
        direction="column"
        //alignItems="flex-start"
        justifyContent="flex-start"
        spacing={4}>
          <Grid item
          >
            <Grid container
              direction="row"
              alignItems="flex-start"
              justifyContent="flex-start"
              spacing={4}
            >
              <Grid item>
                <TextFieldFullWidth
                  id="alias"
                  label="Filnavn der indgår i svaret"
                  placeholder="Graveinstruktioner"
                  helperText="Fritekst"
                  value={fields.alias}
                  onChange={handleFieldChange}
                />
              </Grid>
              <Grid item>
                <Grid container
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="flex-start"
                >
                  <Grid item>
                    <FormControlLabel
                      value={fields.active}
                      control={<Checkbox id="active" size="small" checked={fields.active} value={fields.active} onChange={handleFieldChange} color="primary" />}
                      label="Aktiv"
                      labelPlacement="end"
                    />
                    <FormHelperText>Når dokumentet er markeret som aktivt, vil det blive inkluderet i alle svar til LER.</FormHelperText>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>      
        </Grid>
        <Grid item container spacing={2} style={{ marginTop: 8 }}>
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              disabled={!validateForm}
            >
              {formCreateMode ? "Tilføj dokument" : "Gem Ændringer"}
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="default"
              variant="contained"
              onClick={() => saveAs(props.get(fields.doc_id),fields.alias)}
            >
              Hent dokument
            </Button>
          </Grid>
        </Grid>
        </form>
          </>
        )}
      </CardContent>
    </Card>    
  )
}
